<template>
  <modal :show="show && model" @close="close" class="modal-small">
    <div class="modal-header row">
      <div class="col p-0">
        <h3>{{ isArchived ? 'Unsnooze' : title || 'Snooze' }} referral</h3>
      </div>
      <div class="col text-right p-0">
        <a @click="close" title="Close" href="javascript:void(0)">
          <font-awesome-icon :icon="['far', 'times']" />
        </a>
      </div>
    </div>
    <div class="modal-body">
      <div class="row" v-if="!isArchived">
        <div class="col">
          <p class="py-3 lead">Snoozing the referral will move it out of "Needs Action".
            <span v-if="isSnooze" class="d-inline-block mt-2">Specify a "Snooze Until"" and it will automatically move back at that time.</span>
            <span class="d-inline-block mt-2">Optionally, we recommend that you include a note.</span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Note</label>
            <textarea class="form-control" rows="3" v-model="note"></textarea>
          </div>
        </div>
      </div>
      <div v-if="!isArchived && isSnooze" class="mt-3">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="form-check-label">Snooze Until</label>
            </div>
          </div>
        </div>
        <div class="row form-group" v-if="!isArchived">
          <div class="col">
            <div class="btn-group btn-group-toggle">
              <label class="btn btn-primary" :class="{ active: !autoArchiveOption }">
                <input type="radio" name="options" autocomplete="off" v-model="autoArchiveOption" value />
                Forever
              </label>
              <label class="btn btn-primary" :class="{ active: autoArchiveOption === autoArchiveDates.week }">
                <input type="radio" name="options" autocomplete="off" v-model="autoArchiveOption" :value="autoArchiveDates.week" />7 days
              </label>
              <label class="btn btn-primary" :class="{ active: autoArchiveOption === autoArchiveDates.twoWeeks }">
                <input type="radio" name="options" autocomplete="off" v-model="autoArchiveOption" :value="autoArchiveDates.twoWeeks" />14 days
              </label>
              <label class="btn btn-primary" :class="{
                  active: autoArchiveOption === autoArchiveDates.month,
                }">
                <input type="radio" name="options" autocomplete="off" v-model="autoArchiveOption" :value="autoArchiveDates.month" />30 days
              </label>
              <label v-if="isAppointmentValidForSnooze" class="btn btn-primary" :class="{
                  active: autoArchiveOption === autoArchiveDates.appointment,
                }">
                <input type="radio" name="options" autocomplete="off" v-model="autoArchiveOption" :value="autoArchiveDates.appointment" />
                Appointment
              </label>
              <label class="btn btn-primary" :class="{
                  active:
                    autoArchiveOption &&
                    !Object.keys(autoArchiveDates).some(
                      (k) =>
                        k !== 'custom' &&
                        autoArchiveDates[k] === autoArchiveOption
                    ),
                }">
                <input type="radio" name="options" autocomplete="off" v-model="autoArchiveOption" :value="autoArchiveDates.custom" />
                Custom
              </label>
            </div>
          </div>
        </div>
        <div class="row form-group" v-if="!!autoArchiveOption">
          <div class="col">
            <VueCtkDateTimePicker output-format="YYYY-MM-DDTHH:mm:ssZ" color="#519F85" minute-interval="5" :min-date="moment().toISOString()" v-model="autoArchiveOption" :disabled="!autoArchiveOption" :label="
                autoArchiveOption
                  ? 'Select date & time'
                  : 'Snooze forever'
              " :position="'top'"></VueCtkDateTimePicker>
          </div>
        </div>
      </div>
    </div>
    <div class="row modal-footer pb-0">
      <div class="col">
        <div class="row">
          <div class="col text-right p-0">
            <button class="btn btn-lg btn-primary" @click="snooze" :disabled="isArchiving">
              <font-awesome-icon icon="spinner-third" v-if="isArchiving" spin />
              <span v-else>{{ isArchived ? 'Unsnooze' : 'Snooze' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import { ReferralApi } from '@/services'
import { mapGetters } from 'vuex'

export default {
  props: {
    show: { default: true },
    referralId: { required: true },
    isSnooze: { default: false },
    title: { default: 'Snooze' },
  },
  components: { Modal, VueCtkDateTimePicker },
  data() {
    return {
      isArchiving: false,
      note: '',
      autoArchiveOption: '',
    }
  },
  computed: {
    ...mapGetters('referrals', ['all', 'get']),
    model() {
      return this.get(this.referralId)
    },
    isArchived() {
      return this.model && this.$helpers.isArchived(this.model)
    },
    isAppointmentValidForSnooze() {
      return (
        this.model &&
        this.model.scheduled_time &&
        moment().diff(this.model.scheduled_time) < 0
      )
    },
    autoArchiveDates() {
      return {
        week: moment().add(7, 'days').toISOString(),
        twoWeeks: moment().add(14, 'days').toISOString(),
        month: moment().add(30, 'days').toISOString(),
        appointment: this.isAppointmentValidForSnooze
          ? moment(this.model.scheduled_time)
          : null,
        custom: moment().add(1, 'days').toISOString(),
        // moment().add(5 - (moment().minute() % 5), 'minutes').toISOString(),
      }
    },
  },
  methods: {
    setSnoozeTime(item) {
      const isOwnReferral = !item.is_incoming

      item[`snooze_until_${isOwnReferral ? 'from' : 'to'}_time`] = this
        .isArchived
        ? null
        : this.autoArchiveOption || null
      item[`archived_${isOwnReferral ? 'from' : 'to'}_time`] = this.isArchived
        ? null
        : moment.utc()
    },
    snooze: async function () {
      const _this = this
      let item = { ...this.model }
      this.setSnoozeTime(item)
      this.isArchiving = true
      try {
        await this.$store.dispatch('referrals/save', item)
        // await ReferralApi.save(item);

        if (_this.note)
          await ReferralApi.saveRelated(item.id, 'history', {
            details: this.note,
            referral_id: item.id,
          })
        _this.close()
      } catch (err) {
        this.setSnoozeTime(item)
        this.$helpers.error('Failed to snooze referral')
      }
      _this.isArchiving = false
    },
    close: function () {
      this.note = ''
      this.$emit('close')
    },
  },
}
</script>
<style scoped></style>
<style>
.modal-small div.modal-container {
  height: auto;
  width: 500px;
  max-width: 550px;
  min-width: 500px;
}

.form-group .btn-group.btn-group-toggle label.btn-primary {
  color: #fff;
  cursor: pointer;
}

.modal-body {
  justify-content: center;
  display: flex;
  flex-direction: column;
}
</style>
